export const map_functions = {
	data(){
		return{

		}
	},
	methods: {
		ddToDms(tmpLat, tmpLng) {
			var lat = tmpLat;
			var lng = tmpLng;
			var latResult, lngResult, dmsResult;

			lat = parseFloat(tmpLat);
			lng = parseFloat(tmpLng);

			latResult = (lat >= 0) ? 'N' : 'S';

			// Call to getDms(lat) function for the coordinates of Latitude in DMS.
			// The result is stored in latResult variable.
			latResult += this.getDms(lat);

			lngResult = (lng >= 0) ? 'E' : 'W';

			// Call to getDms(lng) function for the coordinates of Longitude in DMS.
			// The result is stored in lngResult variable.
			lngResult += this.getDms(lng);

			// Joining both variables and separate them with a space.
			dmsResult = latResult + ":" + lngResult;

			// Return the resultant string
			return dmsResult;
		},
		getDms(val) {
			var valDeg, valMin, valSec, result;
			val = Math.abs(val);
			valDeg = Math.floor(val);
			result = valDeg + "g";
			valMin = Math.floor((val - valDeg) * 60);
			result += valMin + "m";
			valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
			result += valSec + 's';

			return result;
		}
	}
}